<template>
  <div class="saas-video-detail">
    <div class="saas-video-detail__main">
      <ul class="breadcrumb-trail">
        <li>
          <nuxt-link :to="{ name: 'videos' }" class="breadcrumb-trail__link"
            >Videos</nuxt-link
          >
          <i class="iconoir-nav-arrow-right breadcrumb-trail__icon"></i>
        </li>
        <li>
          <span class="breadcrumb-trail__link breadcrumb-trail__link--active">{{
            page.title
          }}</span>
        </li>
      </ul>
      <div class="saas-video-detail__title">
        {{ page.title }}
      </div>
      <div class="saas-video-detail__preview">
        <iframe
          width="100%"
          height="100%"
          :src="`https://www.youtube.com/embed/${page.youtube_id}`"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
      <div class="saas-video-detail__body">
        <div class="saas-video-detail__content">
          {{ page.long_description }}
        </div>
      </div>
    </div>
    <FooterJoin></FooterJoin>
  </div>
</template>

<script>
import cmsPage from '@saas/mixins/cmsPage'

export default {
  mixins: [cmsPage],
  layout: 'saas',
}
</script>
